import { render, staticRenderFns } from "./AudienceListTable.vue?vue&type=template&id=65a8be46&scoped=true&"
import script from "./AudienceListTable.vue?vue&type=script&lang=js&"
export * from "./AudienceListTable.vue?vue&type=script&lang=js&"
import style0 from "./AudienceListTable.vue?vue&type=style&index=0&id=65a8be46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8be46",
  null
  
)

export default component.exports